import React from 'react';
import './index.scss';
import { demos } from './data';
import Card from './components/Card';

const Demo: React.FC = () => {
  return (
    <div className="demo-container">
      <div className="demo-header">
        <h1>项目演示</h1>
        <p>展示各种前端技术和实际项目应用</p>
      </div>

      <div className="demo-grid">
        {demos.map((demo) => (
          <Card key={demo.id} demo={demo} />
        ))}
      </div>
    </div>
  );
};

export default Demo;
